var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 3C9.47386 3 9.25 2.77614 9.25 2.5C9.25 2.22386 9.47386 2 9.75 2H13.5C13.7761 2 14 2.22386 14 2.5V6.25C14 6.52614 13.7761 6.75 13.5 6.75C13.2239 6.75 13 6.52614 13 6.25V3.70711L9.35355 7.35355C9.15829 7.54882 8.84171 7.54882 8.64645 7.35355C8.45118 7.15829 8.45118 6.84171 8.64645 6.64645L12.2929 3H9.75ZM2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H7C7.27614 4 7.5 4.22386 7.5 4.5C7.5 4.77614 7.27614 5 7 5H3L3 13H11V9C11 8.72386 11.2239 8.5 11.5 8.5C11.7761 8.5 12 8.72386 12 9V13C12 13.2652 11.8946 13.5196 11.7071 13.7071C11.5196 13.8946 11.2652 14 11 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V5C2 4.73478 2.10536 4.48043 2.29289 4.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcn);
export default __webpack_public_path__ + "static/media/external-link-icn.8f3b79d35c8ecba7c72b1e72a4ebf31b.svg";
export { ForwardRef as ReactComponent };